import type { ApiResponse, GetListResponse } from '@gokrew/models/generic';
import api from './client';
import type {
  CompanyTaskThread,
  CompanyTaskMessage,
  ChangeMyStatusDto,
  CreateMessageDto,
  UpdateMessageDto,
  FilterMyCompanyTasksDto,
  MyAdminTask,
  GetMyAdminTaskDetailResponse,
  AdminTasksSummary,
  CompanyTaskActivityLog,
} from '@gokrew/models/tasks';

const base = '/employee/tasks';

export async function getMyEmployeeTasks(params: FilterMyCompanyTasksDto = {}) {
  return api.get<GetListResponse<MyAdminTask>>(base, { params });
}

export async function getMyEmployeeTasksSummary() {
  return api.get<ApiResponse<AdminTasksSummary>>(`${base}/summary`);
}

export async function getMyEmployeeTaskById(assignmentId: string) {
  return api.get<GetMyAdminTaskDetailResponse>(`${base}/${assignmentId}`);
}

export async function updateMyEmployeeTaskStatus(
  assignmentId: string,
  payload: ChangeMyStatusDto
) {
  return api.patch(`${base}/${assignmentId}/status`, payload);
}

export async function getMyEmployeeTaskActivity(assignmentId: string) {
  return api.get<ApiResponse<CompanyTaskActivityLog[]>>(
    `${base}/${assignmentId}/activity`
  );
}

// ─── Threads & Messages ───────────────────────────────────────

export async function getOrCreateEmployeeTaskThread(assignmentId: string) {
  return api.post<ApiResponse<CompanyTaskThread>>(
    `${base}/${assignmentId}/thread`
  );
}

export async function getEmployeeTaskThread(threadId: string) {
  return api.get<CompanyTaskThread>(`${base}/threads/${threadId}`);
}

export async function getEmployeeTaskThreadMessages(threadId: string) {
  return api.get<ApiResponse<CompanyTaskMessage[]>>(
    `${base}/threads/${threadId}/messages`
  );
}

export async function postEmployeeTaskMessage(
  threadId: string,
  payload: CreateMessageDto
) {
  return api.post<CompanyTaskMessage>(
    `${base}/threads/${threadId}/messages`,
    payload
  );
}

export async function editEmployeeTaskMessage(
  threadId: string,
  messageId: string,
  payload: UpdateMessageDto
) {
  return api.patch<CompanyTaskMessage>(
    `${base}/threads/${threadId}/messages/${messageId}`,
    payload
  );
}

export async function deleteEmployeeTaskMessage(
  threadId: string,
  messageId: string
) {
  return api.delete(`${base}/threads/${threadId}/messages/${messageId}`);
}
